import { env } from "./runtimeConfig";

// Read at runtime from the .env mounted into the container (see runtimeConfig).
// The fallback keeps `npm start` working without a local .env.
//
// TEMP LOCAL TESTING — points at the local backend instead of production.
// Revert to the live URL before committing/deploying.
// const HOST = env("REACT_APP_API_HOST", "http://localhost:1106/");
const HOST = env("REACT_APP_API_HOST", "https://api.scanmeplus.in/");
// const HOST = env("REACT_APP_API_HOST", "https://dev.scanmeapi.vinnisoft.org/");


const BASE_URL = HOST + "api/admin";

export { BASE_URL, HOST };
